type Dimensions = {
  width: number;
  height: number;
};

type Params = {
  greaterThan?: Dimensions;
  lessThan?: Dimensions;
  equalTo?: Dimensions;
};

export const checkImageSize = async (
  file: File,
  params: Params
): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.src = window.URL.createObjectURL(file);

    img.onload = function () {
      const imageWidth = img.naturalWidth;
      const imageHeight = img.naturalHeight;

      const { greaterThan, lessThan, equalTo } = params;

      if (greaterThan) {
        if (
          imageWidth < greaterThan.width ||
          imageHeight < greaterThan.height
        ) {
          resolve(false);
        }
      }
      if (lessThan) {
        if (imageWidth > lessThan.width || imageHeight > lessThan.height) {
          resolve(false);
        }
      }
      if (equalTo) {
        if (imageWidth !== equalTo.width || imageHeight !== equalTo.height) {
          resolve(false);
        }
      }
      resolve(true);
    };

    img.onerror = reject;
  });
};
